module.exports = "https://99designs-start-assets.imgix.net/js/2c058d1a7b5ad6df002ca3ef28b31182.png";